// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
export const PROTOCOL_BLOCKLIST: string[] = [
	'javascript:',
	'data:',
	'vbscript:',
	'view-source:',
	'resource:',
	'about:',
	'chrome:',
	'livescript:',
	'mocha:',
	'file:',
	'mhtml:',
	'smb:',
];

export const sanitizeUrl = (urlString?: string): string => {
	const url = new URL(urlString || '', window.location.href);

	return PROTOCOL_BLOCKLIST.includes(url.protocol) ? 'about:blank' : url.toString();
};
